'use client';

import { ReactNode } from 'react';

export type ShareListModalPropsMicrocopy = {
  title: string;
  subTitle: string;
  assets: string;
  facebookAria: string;
  twitterAria: string;
  emailAria: string;
  twitterShareMessage: string;
  emailShareMessage: string;
  copyUrl: string;
  close: string;
  copied: string;
};

export type ShareListModalPropsData = {
  type: 'personal' | 'organization';
  typeName: string;
  name: string;
  count: number;
  link: string;
};

export type ShareListModalPropsDataWithMicrocopy = ShareListModalPropsData & {
  microcopy: ShareListModalPropsMicrocopy;
};

export type ShareListModalProps = ShareListModalPropsDataWithMicrocopy & {
  className?: string;
  trigger?: ReactNode;
};
